import { Control } from 'react-hook-form';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import type { ExamFormData } from '../utils/examValidation';

interface HearingAssessmentProps {
  control: Control<ExamFormData>;
}

const hearingLevels = ['Normal', 'Mild', 'Moderate', 'Severe'] as const;

export function HearingAssessment({ control }: HearingAssessmentProps) {
  return (
    <div className="space-y-4">
      <FormField
        control={control}
        name="rightEar"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Right Ear Hearing</FormLabel>
            <Select onValueChange={field.onChange} value={field.value}>
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder="Select hearing level" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                {hearingLevels.map((level) => (
                  <SelectItem key={level} value={level}>
                    {level}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={control}
        name="leftEar"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Left Ear Hearing</FormLabel>
            <Select onValueChange={field.onChange} value={field.value}>
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder="Select hearing level" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                {hearingLevels.map((level) => (
                  <SelectItem key={level} value={level}>
                    {level}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
}